import { render, staticRenderFns } from "./tags-searches-list.vue?vue&type=template&id=9c98fd7e"
import script from "./tags-searches-list.vue?vue&type=script&lang=js"
export * from "./tags-searches-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports